import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain";
import useOrganizationLogo from "./useOrganizationLogo";

import { useState } from "react";
import { GetOrganizationAuthenticationOptionsApiRequest } from "../api/SubUsersController";
import {
  IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN,
  TEST_LOCALHOST_CUSTOM_DOMAIN,
} from "utils/globalConsts";

type AuthOptionsT = {
  Email: boolean;
  GoogleSSO: boolean;
  MicrosoftSSO: boolean;
};

const useOrganization = () => {
  const [orgAuthOptions, setOrgAuthOptions] = useState<AuthOptionsT>();
  const [loginSource, setLoginSource] = useState<"google" | "microsoft" | "">(
    ""
  );
  const [topUserPageLink, setTopUserPageLink] = useState<string>("");
  const [orgName, setOrgName] = useState<string>("");

  const { logo, fetchLogo } = useOrganizationLogo();

  const _checkCurrDomainIsOrgDomain = () => checkCurrDomainIsOrgDomain();

  const fetchOrgAuthOptions = async () => {
    const response = await GetOrganizationAuthenticationOptionsApiRequest(
      IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN
        ? TEST_LOCALHOST_CUSTOM_DOMAIN
        : window.location.hostname
    );

    if (response.status === "success" && response.data) {
      setOrgAuthOptions(response.data.AuthenticationOptions);
      setLoginSource(response.data.LoginSource);
      setTopUserPageLink(response.data.TopUserPageLink);
      setOrgName(response.data.OrganizationName);
    }
  };

  const checkIsLoginSourceButtonShown = () => {
    if (_checkCurrDomainIsOrgDomain() && orgAuthOptions) {
      if (
        (loginSource === "google" && !orgAuthOptions.GoogleSSO) ||
        (loginSource === "microsoft" && !orgAuthOptions.MicrosoftSSO) ||
        (!loginSource && !orgAuthOptions.Email)
      ) {
        return true;
      }
    }

    return false;
  };

  const getOrgAuthOptionsBasedOnLoginSource = (): AuthOptionsT => {
    if (loginSource === "google") {
      return {
        GoogleSSO: true,
        MicrosoftSSO: false,
        Email: false,
      };
    } else if (loginSource === "microsoft") {
      return {
        MicrosoftSSO: true,
        GoogleSSO: false,
        Email: false,
      };
    } else {
      return {
        Email: true,
        GoogleSSO: false,
        MicrosoftSSO: false,
      };
    }
  };

  return {
    checkCurrDomainIsOrgDomain: _checkCurrDomainIsOrgDomain,
    fetchOrgAuthOptions,
    orgAuthOptions,
    loginSourceAuthOptions: getOrgAuthOptionsBasedOnLoginSource(),
    loginSource,
    logo,
    fetchLogo,
    checkIsLoginSourceButtonShown,
    topUserPageLink,
    orgName,
  };
};

export default useOrganization;
